import React from 'react';
import { useAtomsDebugValue } from 'jotai-devtools';

const DebugAtoms = () => {
  useAtomsDebugValue()
  return null
}

export default DebugAtoms;
